<h2 mat-dialog-title class="beneficiary-dialog__title">{{ data.title }}</h2>

<mat-dialog-content class="beneficiary-dialog__content">
  @if (data.message) {
    <p class="beneficiary-dialog__message">{{ data.message }}</p>
  }

  <form
    id="beneficiaryUpsertForm"
    (ngSubmit)="submit()"
    class="beneficiary-dialog__form"
    [class.form-submitted]="formSubmitted"
    autocomplete="off"
  >
    <ui-molecule-beneficiary-form
      [form]="form"
      [mode]="data.mode"
      [submitted]="formSubmitted"
    ></ui-molecule-beneficiary-form>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="beneficiary-dialog__actions">
  <ui-atom-button
    type="button"
    rules="main"
    styling="outlined"
    [withShadow]="false"
    [text]="'beneficiaries.form.actions.cancel' | translate"
    [disabled]="isLoading"
    (buttonClick)="onCancel()"
  >
  </ui-atom-button>

  <ui-atom-button
    type="button"
    rules="main"
    styling="filled"
    [withShadow]="true"
    [text]="
      data.mode === 'edit'
        ? ('beneficiaries.form.actions.save' | translate)
        : ('beneficiaries.form.actions.create' | translate)
    "
    [disabled]="isLoading || form.invalid"
    (buttonClick)="submit()"
  >
  </ui-atom-button>
</mat-dialog-actions>
